import { utils, writeFile } from "xlsx";

function saveExel(data) {
    let wb = utils.book_new();
    let ws = utils.json_to_sheet(data);
    utils.book_append_sheet(wb, ws, "MySheets1");
    writeFile(wb, "MyExcel2.xlsx");
}

export default saveExel;